module.exports = __webpack_public_path__ + "assets/img/10-l.2f01e1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/10-l.jpg
// module id = ll0C
// module chunks = 0